
export const imagePageLogin = '/assets/images/logo-page-login.png'
export const image_header = '/assets/images/logo-mene.png'

export const iconCloseModalError = '/assets/images/clear.png'
// export const iconLogoModalError = '/assets/images/icon-deleteCircle-fff.png'
export const LogoModalError = '/assets/images/warning.png'
export const iconCloseOnBG = '/assets/images/icon-delete-fff.png'

//Image Next Prev
export const iconArrowLeft = '/assets/images/icon-arrow-left.png'
export const iconArrowRight = '/assets/images/icon-arrow-right.png'


// WEBPACK FOOTER //
// ./src/app/components/features/config.js